import React from 'react'

export default function Social() {
    return (
        <>
            <div className="social clearfix">
                <div className="one-third column">
                    <a href="https://venmo.com/SecondStory" rel="noopener noreferrer" target="_blank" className="venmo">Venmo</a>
                </div>
                <div className="one-third column">
                    <a href="https://cash.app/$BMyers02" rel="noopener noreferrer" target="_blank" className="cashapp">Cash App</a>
                </div>
                <div className="one-third column">
                    <a href="https://www.paypal.com/paypalme2/BMyers02?locale.x=en_US" rel="noopener noreferrer" target="_blank" className="paypal">PayPal</a>
                </div>
            </div>
        </>
    )
}
